module.exports = __webpack_public_path__ + "img/maquina-de-cartao.d5c33765.png";